import { MakeCall } from 'ha/services/apiV2/createMakeCall';

enum CodeRequestTypes {
  sms = 'sms',
  voice = 'voice',
}

export interface CodeRequest {
  type: CodeRequestTypes;
  recaptchaToken: string;
}

export default (makeCall: MakeCall) =>
  (userId: number, { type, recaptchaToken }: CodeRequest) =>
    makeCall<undefined>('POST', `/api/v2/user/${userId}/request-code`, {
      data: {
        type,
        recaptchaToken,
      },
    });
